import React, { FC } from "react"
import { Typography } from "antd"
const { Text } = Typography

export interface HeaderTextProp {
    title: string
}

export const HeaderText: FC<HeaderTextProp> = (props) => {
    return (
        <Text strong className="headerText">{props.title}</Text>
    )
}